import React, { ReactElement, useEffect, useRef } from 'react'
import Dropdown from '../../components/Dropdown'

type DropdownProps = React.ComponentProps<typeof Dropdown>

/**
 * The shared Dropdown only closes on outside clicks; this wrapper also closes
 * it when Escape is pressed so every select in the Send flow is
 * keyboard-dismissable.
 */
const EscapableDropdown = (props: DropdownProps): ReactElement => {
  const closeFnRef = useRef<() => void>()

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        closeFnRef.current?.()
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [])

  return <Dropdown
    {...props}
    onCloseFn={fn => {
      closeFnRef.current = fn
      props.onCloseFn?.(fn)
    }} />
}

export default EscapableDropdown
